export function renderSelectReadValuesExpressionSelectValueTemplate({
  dataSource,
  fieldName
}: {
  dataSource: string
  fieldName: string
}): string {
  return `(() => {
        const selectValue = ${dataSource}?.${fieldName} as unknown
        const values = Array.isArray(selectValue) ? selectValue : [selectValue]
        return values
          .map((option) => {
            if (typeof option === 'string') return option
            if (option && typeof option === 'object' && 'value' in option) {
              return String(option.value)
            }
            return null
          })
          .filter((value): value is string => typeof value === 'string' && value.length > 0)
      })()`
}
